import type { ComponentProps } from 'react'

import { Toast } from '@base-ui/react'
import styled from 'styled-components'

const SnackbarViewport = styled.div`
	bottom: 16px;
	left: 16px;
	margin-inline: auto;
	position: fixed;
	right: 16px;
	top: auto;
	width: min(600px, calc(100vw - 32px));
	z-index: 1000;

	@media (min-width: 500px) {
		left: auto;
	}

	@media (max-width: 499px) {
		width: calc(100vw - 32px);
	}
`

type Props = ComponentProps<typeof Toast.Viewport>

export const Viewport = ({ ...rest }: Props) => (
	<Toast.Viewport {...rest} render={(props) => <SnackbarViewport {...props} />} />
)
